import React from 'react';
import { RoundedBar } from '../../../../shared/components/ui/atoms';

import './StepBar.scss';

interface StepBarProps {
  selectedStep?: number;
  isWide?: boolean;
  isWider?: boolean;
}

interface StepBarContentProps {
  options: string[];
  selectedStep: number;
  setSelectedStep: (index: number) => void;
}

export const StepBar = (props: StepBarProps) => {
  const { selectedStep = 0, isWide, isWider } = props;
  const OPTIONS = ["Background", "Loan Builder"]

  const className = (
    isWide
    ?
    'step-bar wide'
    :
    (
      isWider
      ? 
      'step-bar wider'
      :
      'step-bar'
    )
  )

  return (
    <div className={className}>
      <StepBarContent options={OPTIONS} selectedStep={selectedStep} setSelectedStep={() => {}} />
    </div>
  );
}

export const StepBarContent = ({ options, selectedStep, setSelectedStep }: StepBarContentProps) => (
  <div className='step-bar-content'>
    {
      options.map(
        (option: string, i: number) => {
          const isDisabled = selectedStep !== i
          const className = isDisabled ? 'disabled' : undefined
          return (
            <div key={`${option}_${i}`} className={className} onClick={() => setSelectedStep(i)}>
              {option}
              <RoundedBar isDisabled={isDisabled} />
            </div>
          )
        }
      )
    }
  </div>
)